import { HttpCodeProps } from "../types";

export const HttpCodes = {
  Success: 200 as HttpCodeProps,
  Created: 201 as HttpCodeProps,
  Accepted: 202 as HttpCodeProps,
  NoContent: 204 as HttpCodeProps,
  BadRequest: 400 as HttpCodeProps,
  Unauthorized: 401 as HttpCodeProps,
  Forbidden: 403 as HttpCodeProps,
  NotFound: 404 as HttpCodeProps,
  MethodNotAllowed: 405 as HttpCodeProps,
  Conflict: 409 as HttpCodeProps,
  InternalServerError: 500 as HttpCodeProps,
};

export const AppName = "Virel";
export const AppFullName = "Virel - Reward Your Lifestyle";

export const AppEmail = "info@nakuzisa.com";
export const AppWebsite = "https://nakuzisa.com";

export const AppAddress = "NO. 31, OKE STREET, OJOKORO, LAGOS STATE, NIGERIA";

export const GooglePlayStoreDownloadLink =
  "https://play.google.com/store/apps/details?id=com.nakuzisa.virel";

export const AppStoreDownloadLink =
  "https://apps.apple.com/app/id6767821374";
